import {
  otherInsufficientAdd, otherInsufficientReject, otherInsufficientApprove,
  manualInsufficientReferenceData, referenceInsufficientApprove, referenceInsufficientReject, educationEmploymentCostAdd,
  listAdditionalCost,
  approverForFinanceVerification,
  updateOtherExpenses,
  recallAdditionalCost,
  cancelAdditionalCost,
  financeRecallDecision,
  listAdditionalExpenseDetails,
  addCommentsPendingChecks,
  deleteCommentsPendingChecks
} from "../actions/InsufficientRunAction";
import { createSlice } from "@reduxjs/toolkit";

const otherInsufficientAddSlice = createSlice({
  name: "otherInsufficientAdd",
  initialState: {
    loading: false,
    data: null,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(otherInsufficientAdd.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(otherInsufficientAdd.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        // Call the success callback if provided
        if (typeof action.meta.arg.successFn === "function") {
          action.meta.arg.successFn(action.payload);
          console.log("action page", action.payload);
        }
      })
      .addCase(otherInsufficientAdd.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
        // Call the failure callback if provided
        if (typeof action.meta.arg.failureFn === "function") {
          action.meta.arg.failureFn(action.error.message);
          console.log("action:::", action.error.message);
        }
      });
  },
});

const otherInsufficientRejectSlice = createSlice({
  name: "otherInsufficientReject",
  initialState: {
    loading: false,
    data: null,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(otherInsufficientReject.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(otherInsufficientReject.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        // Call the success callback if provided
        if (typeof action.meta.arg.successFn === "function") {
          action.meta.arg.successFn(action.payload);
          console.log("action page", action.payload);
        }
      })
      .addCase(otherInsufficientReject.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
        // Call the failure callback if provided
        if (typeof action.meta.arg.failureFn === "function") {
          action.meta.arg.failureFn(action.error.message);
          console.log("action:::", action.error.message);
        }
      });
  },
});


const otherInsufficientApproveSlice = createSlice({
  name: "otherInsufficientApprove",
  initialState: {
    loading: false,
    data: null,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(otherInsufficientApprove.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(otherInsufficientApprove.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        // Call the success callback if provided
        if (typeof action.meta.arg.successFn === "function") {
          action.meta.arg.successFn(action.payload);
          console.log("action page", action.payload);
        }
      })
      .addCase(otherInsufficientApprove.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
        // Call the failure callback if provided
        if (typeof action.meta.arg.failureFn === "function") {
          action.meta.arg.failureFn(action.error.message);
          console.log("action:::", action.error.message);
        }
      });
  },
});

const manualInsufficientReferenceDataSlice = createSlice({
  name: "manualInsufficientReferenceData",
  initialState: {
    loading: false,
    data: null,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(manualInsufficientReferenceData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(manualInsufficientReferenceData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        // Call the success callback if provided
        if (typeof action.meta.arg.successFn === "function") {
          action.meta.arg.successFn(action.payload);
          console.log("action page", action.payload);
        }
      })
      .addCase(manualInsufficientReferenceData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
        // Call the failure callback if provided
        if (typeof action.meta.arg.failureFn === "function") {
          action.meta.arg.failureFn(action.error.message);
          console.log("action:::", action.error.message);
        }
      });
  },
});


const referenceInsufficientApproveSlice = createSlice({
  name: "referenceInsufficientApprove",
  initialState: {
    loading: false,
    data: null,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(referenceInsufficientApprove.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(referenceInsufficientApprove.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        // Call the success callback if provided
        if (typeof action.meta.arg.successFn === "function") {
          action.meta.arg.successFn(action.payload);
          console.log("action page", action.payload);
        }
      })
      .addCase(referenceInsufficientApprove.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
        // Call the failure callback if provided
        if (typeof action.meta.arg.failureFn === "function") {
          action.meta.arg.failureFn(action.error.message);
          console.log("action:::", action.error.message);
        }
      });
  },
});


const referenceInsufficientRejectSlice = createSlice({
  name: "referenceInsufficientReject",
  initialState: {
    loading: false,
    data: null,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(referenceInsufficientReject.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(referenceInsufficientReject.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        // Call the success callback if provided
        if (typeof action.meta.arg.successFn === "function") {
          action.meta.arg.successFn(action.payload);
          console.log("action page", action.payload);
        }
      })
      .addCase(referenceInsufficientReject.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
        // Call the failure callback if provided
        if (typeof action.meta.arg.failureFn === "function") {
          action.meta.arg.failureFn(action.error.message);
          console.log("action:::", action.error.message);
        }
      });
  },
});


const educationEmploymentCostAddSlice = createSlice({
  name: "educationEmploymentCostAdd",
  initialState: {
    loading: false,
    data: null,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(educationEmploymentCostAdd.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(educationEmploymentCostAdd.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        // Call the success callback if provided
        if (typeof action.meta.arg.successFn === "function") {
          action.meta.arg.successFn(action.payload);
          console.log("action page", action.payload);
        }
      })
      .addCase(educationEmploymentCostAdd.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
        // Call the failure callback if provided
        if (typeof action.meta.arg.failureFn === "function") {
          action.meta.arg.failureFn(action.error.message);
          console.log("action:::", action.error.message);
        }
      });
  },
});

const listAdditionalCostSlice = createSlice({
  name: "listAdditionalCost",
  initialState: {
    loading: false,
    data: null,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(listAdditionalCost.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(listAdditionalCost.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        // Call the success callback if provided
        if (typeof action.meta.arg.successFn === "function") {
          action.meta.arg.successFn(action.payload);
          console.log("action page", action.payload);
        }
      })
      .addCase(listAdditionalCost.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
        // Call the failure callback if provided
        if (typeof action.meta.arg.failureFn === "function") {
          action.meta.arg.failureFn(action.error.message);
          console.log("action:::", action.error.message);
        }
      });
  },
});

const approverForFinanceVerificationSlice = createSlice({
  name: "approverForFinanceVerification",
  initialState: {
    loading: false,
    data: null,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(approverForFinanceVerification.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(approverForFinanceVerification.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        // Call the success callback if provided
        if (typeof action.meta.arg.successFn === "function") {
          action.meta.arg.successFn(action.payload);
          console.log("action page", action.payload);
        }
      })
      .addCase(approverForFinanceVerification.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
        // Call the failure callback if provided
        if (typeof action.meta.arg.failureFn === "function") {
          action.meta.arg.failureFn(action.error.message);
          console.log("action:::", action.error.message);
        }
      });
  },
});

const listAdditionalExpenseDetailsSlice = createSlice({
  name: "listAdditionalExpenseDetails",
  initialState: { loading: false, data: null, error: null },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(listAdditionalExpenseDetails.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(listAdditionalExpenseDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        if (typeof action.meta.arg.successFn === "function") {
          const cb = action.meta.arg.successFn;
          const payload = action.payload;
          setTimeout(() => cb(payload), 0);
        }
      })
      .addCase(listAdditionalExpenseDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
        if (typeof action.meta.arg.failureFn === "function") {
          const cb = action.meta.arg.failureFn;
          const msg = action.error.message;
          setTimeout(() => cb(msg), 0);
        }
      });
  },
});

const updateOtherExpensesSlice = createSlice({
  name: "updateOtherExpenses",
  initialState: { loading: false, data: null, error: null },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(updateOtherExpenses.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateOtherExpenses.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        if (typeof action.meta.arg.successFn === "function") {
          const cb = action.meta.arg.successFn;
          const payload = action.payload;
          setTimeout(() => cb(payload), 0);
        }
      })
      .addCase(updateOtherExpenses.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
        if (typeof action.meta.arg.failureFn === "function") {
          const cb = action.meta.arg.failureFn;
          const msg = action.error.message;
          setTimeout(() => cb(msg), 0);
        }
      });
  },
});

const addCommentsPendingChecksSlice = createSlice({
  name: "addCommentsPendingChecks",
  initialState: {
    loading: false,
    data: null,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(addCommentsPendingChecks.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addCommentsPendingChecks.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        // Call the success callback if provided
        if (typeof action.meta.arg.successFn === "function") {
          action.meta.arg.successFn(action.payload);
          console.log("action page", action.payload);
        }
      })
      .addCase(addCommentsPendingChecks.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
        // Call the failure callback if provided
        if (typeof action.meta.arg.failureFn === "function") {
          action.meta.arg.failureFn(action.error.message);
          console.log("action:::", action.error.message);
        }
      });
  },
});

const deleteCommentsPendingChecksSlice = createSlice({
  name: "deleteCommentsPendingChecks",
  initialState: {
    loading: false,
    data: null,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(deleteCommentsPendingChecks.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteCommentsPendingChecks.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        // Call the success callback if provided
        if (typeof action.meta.arg.successFn === "function") {
          action.meta.arg.successFn(action.payload);
          console.log("action page", action.payload);
        }
      })
      .addCase(deleteCommentsPendingChecks.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
        // Call the failure callback if provided
        if (typeof action.meta.arg.failureFn === "function") {
          action.meta.arg.failureFn(action.error.message);
          console.log("action:::", action.error.message);
        }
      });
  },
});

const recallAdditionalCostSlice = createSlice({
  name: "recallAdditionalCost",
  initialState: { loading: false, data: null, error: null },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(recallAdditionalCost.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(recallAdditionalCost.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        if (typeof action.meta.arg.successFn === "function") {
          action.meta.arg.successFn(action.payload);
        }
      })
      .addCase(recallAdditionalCost.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
        if (typeof action.meta.arg.failureFn === "function") {
          action.meta.arg.failureFn(action.error.message);
        }
      });
  },
});

const cancelAdditionalCostSlice = createSlice({
  name: "cancelAdditionalCost",
  initialState: { loading: false, data: null, error: null },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(cancelAdditionalCost.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(cancelAdditionalCost.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        if (typeof action.meta.arg.successFn === "function") {
          action.meta.arg.successFn(action.payload);
        }
      })
      .addCase(cancelAdditionalCost.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
        if (typeof action.meta.arg.failureFn === "function") {
          action.meta.arg.failureFn(action.error.message);
        }
      });
  },
});

const financeRecallDecisionSlice = createSlice({
  name: "financeRecallDecision",
  initialState: { loading: false, data: null, error: null },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(financeRecallDecision.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(financeRecallDecision.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        if (typeof action.meta.arg.successFn === "function") {
          action.meta.arg.successFn(action.payload);
        }
      })
      .addCase(financeRecallDecision.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
        if (typeof action.meta.arg.failureFn === "function") {
          action.meta.arg.failureFn(action.error.message);
        }
      });
  },
});

export const reducers = {
  otherInsufficientAdd: otherInsufficientAddSlice.reducer,
  otherInsufficientReject: otherInsufficientRejectSlice.reducer,
  otherInsufficientApprove: otherInsufficientApproveSlice.reducer,
  manualInsufficientReferenceData: manualInsufficientReferenceDataSlice.reducer,
  referenceInsufficientApprove: referenceInsufficientApproveSlice.reducer,
  referenceInsufficientReject: referenceInsufficientRejectSlice.reducer,
  educationEmploymentCostAdd: educationEmploymentCostAddSlice.reducer,
  listAdditionalCost: listAdditionalCostSlice.reducer,
  approverForFinanceVerification:approverForFinanceVerificationSlice.reducer,
  updateOtherExpenses: updateOtherExpensesSlice.reducer,
  recallAdditionalCost: recallAdditionalCostSlice.reducer,
  cancelAdditionalCost: cancelAdditionalCostSlice.reducer,
  financeRecallDecision: financeRecallDecisionSlice.reducer,
  listAdditionalExpenseDetails: listAdditionalExpenseDetailsSlice.reducer,
  addCommentsPendingChecks:addCommentsPendingChecksSlice.reducer,
  deleteCommentsPendingChecks: deleteCommentsPendingChecksSlice.reducer
};
